// The auth guard is used to prevent unauthenticated users from accessing restricted routes

import { Injectable } from '@angular/core';
import {
	Router,
	CanActivate,
	ActivatedRouteSnapshot,
	RouterStateSnapshot
} from '@angular/router';
import { AuthenticationService } from '../_services/index';
import { Observable } from 'rxjs';
import { tap, map, take } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable()
export class AuthGuard implements CanActivate {
	constructor(
		private auth: AuthenticationService,
		private router: Router,
		private spinner: NgxSpinnerService
	) {}

	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	  ): Observable<boolean> | Promise<boolean> | boolean {
		this.spinner.show();
		return this.auth.user.pipe(
		  take(1),
		  map(user => !!user),
		  tap(loggedIn => {
			if (!loggedIn) {
			  console.log('access denied');
			//   this.notify.update('You must be logged in!', 'error');
			  this.router.navigate(['/login']);
			}
		  })
		);
	  }

	// canActivate(
	// 	next: ActivatedRouteSnapshot,
	// 	state: RouterStateSnapshot
	// ): Observable<boolean> | boolean {
	// 	this.spinner.show(); // When first accessing the page
	// 	return this.auth.user
	// 		.take(1)
	// 		.map(user => !!user)
	// 		.do(loggedIn => {
	// 			if (!loggedIn) {
	// 				console.log('access denied');
	// 				this.router.navigate(['/login']);
	// 			}
	// 		});
	// }
}
